import React, { useRef, useEffect } from 'react';
import { Form, Input, DatePicker, Checkbox } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import cloneDeep from 'lodash/cloneDeep';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

function ProjectExperience(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  const { campusResumeDetail, socialResumeDetail, socialResumeFormRefStore, campusResumeFormRefStore } = useRootStore();
  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeProjectExpListRef', formRefs.current);
    const cloneData = cloneDeep(data);
    cloneData?.map((item, index) => {
      formRefs.current[index]?.setFieldsValue({
        endDate: item.endDate === 253370736000000 ? 0 : item.endDate,
      });
      return null;
    });
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumeProjectExpList(index, formItemKey, formItemValue);
  };

  return (
    <div className="project_experience_edit model_edit">
      <div className="model_title">项目经历</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            {type === 'social' && (
              <FormItem
                formItemKey="companyName"
                span="11"
                labelWidth={0}
                required
                message="请填写公司名称"
                rules={[
                  {
                    required: true,
                    message: '请填写公司名称',
                  },
                  {
                    type: 'string',
                    max: 100,
                    message: '公司名称不能超过100字',
                  },
                ]}
              >
                <div className="label">
                  公司名称<span className="icon">*</span>
                </div>
                <Input toFormItem size="large" placeholder="请选择" maxLength={100} />
              </FormItem>
            )}
            <FormItem
              formItemKey="projectName"
              span="11"
              labelWidth={0}
              required
              message="请填写项目名称"
              rules={[
                {
                  required: true,
                  message: '请填写项目名称',
                },
                {
                  type: 'string',
                  max: 100,
                  message: '项目名称不能超过100字',
                },
              ]}
            >
              <div className="label">
                项目名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入项目名称" maxLength={100} />
            </FormItem>
            <FormItem
              formItemKey="projectPosition"
              span="11"
              labelWidth={0}
              required
              message="请填写项目角色"
              rules={[
                {
                  required: true,
                  message: '请填写项目角色',
                },
                {
                  type: 'string',
                  max: 100,
                  message: '项目角色不能超过100字',
                },
              ]}
            >
              <div className="label">
                项目角色 <span className="icon">*</span>
              </div>

              <Input toFormItem size="large" placeholder="请输入项目角色" maxLength={100} />
            </FormItem>
            <FormItem
              className="form_item_start_date"
              formItemKey="startDate"
              span="4"
              labelWidth={0}
              required
              message="请填写开始时间"
            >
              <div className="label">
                项目时间<span className="icon">*</span>
              </div>
              <DatePicker
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="开始时间"
                disabledDate={(cur) => {
                  if (item?.endDate) return cur > item.endDate;
                  return false;
                }}
              />
              <div className="inner-line" />
            </FormItem>
            <FormItem
              className="form_item_end_date"
              formItemKey="endDate"
              span="3"
              labelWidth={0}
              required
              message="请填写结束时间"
            >
              <div className="label"> </div>
              <DatePicker
                disabled={store.resumeProjectExpList[index].endDate === 253370736000000}
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="结束时间"
                disabledDate={(cur) => {
                  if (item?.startDate) return cur < item.startDate;
                  return false;
                }}
              />
            </FormItem>

            <FormItem className="form_item_up_to_now" formItemKey="upToNow" span="1" labelWidth={0}>
              <div className="label"> </div>
              <Checkbox
                checked={store.resumeProjectExpList[index].endDate === 253370736000000}
                onChange={(e) => {
                  if (e.target.checked) {
                    store.setResumeProjectExpList(index, 'endDate', 253370736000000);
                    formRefs.current[index]?.setFieldsValue({ endDate: 0 });
                    formRefs.current[index]?.validateFields(['endDate']);
                  } else {
                    store.setResumeProjectExpList(index, 'endDate', '');
                    formRefs.current[index]?.setFieldsValue({ endDate: '' });
                  }
                }}
              >
                至今
              </Checkbox>
            </FormItem>
            <FormItem formItemKey="projectUrl" span="11" labelWidth={0}>
              <div className="label">项目链接</div>
              <Input toFormItem size="large" placeholder="请输入项目链接" maxLength={1000} />
            </FormItem>
            <FormItem formItemKey="projectDescription" span="11" labelWidth={0}>
              <div className="label">项目描述</div>
              <Input.TextArea
                className="input_text_area"
                toFormItem
                placeholder="请输入项目描述"
                showCount
                maxLength={2000}
                autosize={{ minRows: 2, maxRows: 6 }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeProjectExpList', index)}>删除这段经历</div>
          </div>
        </div>
      ))}
      <div className="list_add" onClick={() => store.addResumeList('resumeProjectExpList')}>
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加项目经历
      </div>
    </div>
  );
}

export default ModuleView(observer(ProjectExperience), 'projectExperience');
